import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { useOpenMapServicesModal } from '~/integrations/Accounting/MapServicesModal/useOpenMapServicesModal';
import { Accounting } from '~/types/api.model';
export const GetMapServiceSlotTID = (parentTestId)=>getTestIds(parentTestId);
export const MapServiceSlot = (param)=>{
    let { service, onMapped, testId } = param;
    const { t } = useLocaleKeys('components.billClientModal.timeActivities');
    const { MapServiceSlotTestIds } = useMemo(()=>GetMapServiceSlotTID(testId), [
        testId
    ]);
    const serviceTemplateIds = getAccountingDetails(Accounting.QBO).policy.getServiceTemplateIdsFromServices([
        service
    ]);
    const openMapServicesModal = useOpenMapServicesModal(serviceTemplateIds, onMapped);
    return /*#__PURE__*/ _jsx(TextButton, {
        bi: {
            name: 'map_service_to_billing_item'
        },
        testId: MapServiceSlotTestIds.Button(),
        underline: "none",
        onClick: ()=>openMapServicesModal(Accounting.QBO),
        children: t.mapService()
    });
};
